import { render, staticRenderFns } from "./AppDeploypreview.vue?vue&type=template&id=c8a328f8&scoped=true&"
import script from "./AppDeploypreview.vue?vue&type=script&lang=js&"
export * from "./AppDeploypreview.vue?vue&type=script&lang=js&"
import style0 from "./AppDeploypreview.vue?vue&type=style&index=0&id=c8a328f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a328f8",
  null
  
)

export default component.exports